<template>
  <modal-campaign-targeting-rule @save="save" @close="close">
    <div class="d-flex align-items-center">
      <span class="mr-2 flex-shrink-0">The visitors who are</span>
      <select class="form-control form-control-sm mr-2 w-auto" v-model="value">
        <option value="detected">use</option>
        <option value="not-detected">don't use</option>
        <span class="flex-shrink-0">AdBlock, AdBlock Plus, etc.</span>
      </select>
    </div>
  </modal-campaign-targeting-rule>
</template>

<script>
import ModalCampaignTargetingRule from "@/components/modals/ModalCampaignTargetingRule"
import targetingRuleNames from "@/components/campaign-targeting-rules/targetingRuleNames"
import targetingRuleModalMixin from "@/components/campaign-targeting-rules/modals/targeting-rule-modal-mixin"

const mixin = targetingRuleModalMixin("who", targetingRuleNames.whoRules.adblock)

export default {
  name: "AdblockModal",
  components: { ModalCampaignTargetingRule },
  mixins: [mixin]
}
</script>
